<template>
  <div>
    <div class="bolder indigo-text text-bolder">
      [상태({{selectStatus}}) : {{filteredStudents.length}} 명]
    </div>
    <mdb-tbl hover sm>
      <mdb-tbl-head>
        <tr class='table-header'>
          <th>No</th>
          <th>사용자 ID</th>
          <th>이름</th>
          <th>email</th>
          <th>상태
            <select v-model="selectStatus" class="select-underline">
              <option v-for="(s, index) in status" :key="index">{{s}}</option>
            </select>
          </th>
          <th>성별</th>
          <th>핸드폰</th>
        </tr>
      </mdb-tbl-head>
      <mdb-tbl-body>
        <tr v-for="(s, index) in filteredStudents" :key="index">
          <td>{{index+1}}</td>
          <td><span @click="$emit('change-mode', 'VIEW', s.userId)" class="pointer">{{s.userId}}</span></td>
          <td>{{s.name}}</td>
          <td>{{s.email}}</td>
          <td>{{s.status}}</td>
          <td>{{s.gender}}</td>
          <td>{{s.cellPhone.number1}}-{{s.cellPhone.number2}}-{{s.cellPhone.number3}}</td>
        </tr>
      </mdb-tbl-body>
    </mdb-tbl>
  </div>
</template>
<script>
import { mdbTbl, mdbTblHead, mdbTblBody } from 'mdbvue';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  name: 'StudentList',
  components: { mdbTbl, mdbTblHead, mdbTblBody },
  props: ['students', 'status'],
  data: () => ({
    selectStatus: '모두'
  }),
  computed: {
    ...mapState('auth', ['org']),
    filteredStudents () {
      return this.selectStatus === '모두' ? this.students : this.students.filter(s => s.status === this.selectStatus);
    }
  }
}
</script>
